<template>
  <div>
    <div class="row">
      <div :class="['col_12', { loading_overlay: loading }]">
        <div class="card no_border">
          <div class="card-header">
            <div class="card-title">랜딩페이지관리</div>
          </div>
          <div class="card-body pl_0 pr_0">
            <div class="row">
              <div class="col_4">
                <div :class="['form-group', { has_error: errorFor('title') }]">
                  <label class="required">제목</label>
                  <input type="text" class="form_global" v-model="form.title" />
                  <v-errors :errors="errorFor('title')" />
                </div>
              </div>
              <div class="col_4">
                <div
                  :class="['form-group', { has_error: errorFor('page_url') }]"
                >
                  <label class="">랜딩페이지 주소</label>
                  <input
                    type="text"
                    class="form_global"
                    v-model="form.page_url"
                  />
                  <v-errors :errors="errorFor('page_url')" />
                </div>
              </div>

              <div class="col_4">
                <div :class="['form-group', { has_error: errorFor('status') }]">
                  <label>{{ $t('common.status') }}</label>
                  <div class="form_inline">
                    <div class="form_radio">
                      <input
                        type="radio"
                        id="active"
                        value="1"
                        v-model="form.status"
                      />
                      <label for="active">{{ $t('common.active') }}</label>
                    </div>
                    <div class="form_radio">
                      <input
                        type="radio"
                        id="inactive"
                        value="0"
                        v-model="form.status"
                      />
                      <label for="inactive">{{ $t('common.inactive') }}</label>
                    </div>
                  </div>
                  <v-errors :errors="errorFor('status')" />
                </div>
              </div>
            </div>

            <div class="d_flex_end form_action_btn">
              <router-link
                class="btn btn_danger ml_10"
                :to="{ name: cancelRouteName }"
                >{{ $t('common.cancel') }}</router-link
              >
              <button
                class="btn btn_blue ml_10"
                :disabled="loading"
                @click.prevent="submit"
              >
                {{ $t('common.save') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      cancelRouteName: 'landing_page_list',
      form: {
        title: '',
        page_url: '',
        status: 0,
      },
    };
  },
  created() {
    if (this.$route.name === 'landing_page_edit') {
      this.axios
        .get('/landing-pages/' + this.$route.params.id)
        .then((response) => {
          let editPackageData = response.data.data;
          this.form.title = editPackageData.title;
          this.form.page_url = editPackageData.page_url;
          this.form.status = editPackageData.status;
        });
    }
  },
  watch: {},
  methods: {
    submit() {
      this.allErrors = null;
      this.loading = true;

      if (this.$route.name === 'landing_page_edit') {
        this.axios
          .patch('/landing-pages/' + this.$route.params.id, this.form)
          .then(() => {
            this.$router.push({ name: 'landing_page_list' });
            this.showSuccessMsg(this.$t('common.updateSuccess'));
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.axios
          .post('/landing-pages', this.form)
          .then(() => {
            this.$router.push({ name: 'landing_page_list' });
            this.showSuccessMsg(this.$t('common.addSuccess'));
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
<style scoped>
.dp__menu {
  top: 196px;
}
</style>
